// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_upload {
  height: 75vh;
  width: 60vw;
  background-color: white;
  position: relative;
  margin: 5% auto;
  border-radius: 10px;
  padding: 0.5rem 2rem;
  font-family: "Open Sans", sans-serif;
}

.stepOne-container {
  justify-content: space-around;
}

.step_first {
  display: flex;
  flex-flow: column;
}

.upload_slide1 {
  height: auto;
}

.file_list_slide1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 3rem;
  padding: 0 1.5rem;
  font-weight: 700;
  max-width: 90%;
}

.file_list_slide1 img {
  cursor: pointer;
}

.file_list_slide_override {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 3rem;
  font-weight: 700;
}

.file_title_list {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 90%;
}

.text_counter_container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 11px;
  color: #53565a;
}

.file_title_list p {
  font-size: 14px;
  font-weight: 400;
  width: auto;
  max-width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.override_list {
  display: flex;
  flex-direction: row;
  width: 80%;
  align-items: center;
}

.override_list p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.upload_dropzone {
  height: 20vh;
  background-color: #e4e4e49d;
  border-radius: 4px;
  border: 2px dashed rgb(117, 117, 117);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dropzone_info {
  height: 20%;
  width: 80%;
  display: flex;
  align-items: center;
}

.iconText_container {
  display: flex;
  align-items: center;
}

.dropzone_info hr {
  height: 5vh;
  width: 0.1vw;
  border-width: 0;
  color: #a7a8aa;
  background-color: #a7a8aa;
}

.dropzone_info h2 {
  margin: 0 0.5rem;
  font-size: 14px;
  font-weight: 700;
}

.remove_file_btn {
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 3px;
  background-color: transparent;
  border: none;
}

.grid-files {
  display: grid;
  grid-template-areas: "drop-input files_container";
  grid-template-columns: 1fr 1.5fr;
  column-gap: 25px;
}

.files_container {
  grid-area: files_container;
  background-color: #f5f5f5;
  border: 1px solid #d0d0ce;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
}

.files_container_header {
  display: flex;
  height: 15%;
  background-color: white;
  border-bottom: 1px solid #d0d0ce;
  padding: 0 2rem;
  align-items: center;
  font-size: 12px;
  border-radius: 8px;
}

.files_container_header h1 {
  font-size: 16px;
  font-weight: 600;
}

.files_container_content {
  overflow-y: scroll;
  padding: 2rem 1rem;
  max-height: 30vh;
}

.upload_icon {
  height: 24px;
  width: 24px;
  background-color: var(--primary-main);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.drop_text_container {
  display: flex;
  justify-content: center;
  width: 70%;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}

.upload_btn_modal {
  height: 50%;
  width: auto;
  padding: 0 10px;
  border-radius: 4px;
  border: none;
  background-color: var(--primary-main);
  color: white;
  font-weight: 700;
  cursor: grab;
}

.upload_modal_btn_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1rem;
}

.error_message {
  color: red;
}

.upload_slide2_content {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.filesDiv {
  display: flex;
  flex-flow: column;
  overflow-y: scroll;
  height: 20vh;
  width: 100%;
}

.filesDetailList {
  display: flex;
  flex-flow: column;
  overflow-y: auto;
  max-height: 50vh;
  margin-top: 20px;
}

.slide2_files {
  height: 80%;
  width: 40%;
  display: flex;
  overflow: scroll;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem 1rem;
}

.slide2_files h2 {
  margin: 0;
}

.slide2_details h2 {
  margin: 0;
}

.slide2_details {
  height: 80%;
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 1rem 3rem;
  border-left: 1px solid #a7a8aa;
  text-align: start;
}

.slide2_detaile_title {
  align-items: center;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.slide2_detaile_title p {
  font-size: 10px;
}

.slide2_details form {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.fileName_listed {
  display: flex;
  flex-direction: row;
}

.fileName_container {
  height: auto;
  background-color: transparent;
  display: flex;
  width: 25vw;
  align-items: center;
  padding: 1rem;
  border: none;
  color: black;
  margin-top: 1.5rem;
  cursor: pointer;
  transition: transform 0.3s ease;
  padding-left: 20px;
  padding-right: 2rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.fileName_container p {
  margin: 0;
  width: calc(90% - 15px);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  white-space: nowrap;
}

.slide2_footer {
  display: flex;
  justify-content: flex-end;
}

.fileName {
  background-color: #f5f5f5;
  padding: 8px 0px;
  padding-left: 8px;
  column-gap: 10px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  font-weight: 700;
}

.fileName-selected {
  background-color: var(--primary-main);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  width: 4px;
  height: 40px;
}

.fileName_container.selected {
  background-color: #f5f5f5;
  transform: translate(50);
  transform: translateX(10px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.grid-override {
  display: grid;
  grid-template-areas: "drop-input" "selectedFiles";
  grid-template-rows: 4fr 0.5fr;
}

.fileName_container.selected::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background-color: var(--primary-main);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.upload_slide3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.upload_slide3 h1 {
  margin: 0;
}

.loader {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 5;
  background-color: rgba(66, 66, 66, 0.301);
  display: flex;
  align-items: center;
  justify-content: center;
}

.files_container_content h6 {
  margin: 2rem 2rem;
  font-size: 13px;
  font-weight: 400;
}

.upload_title {
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 1rem;
}

.reset_btn {
  border: none;
  color: var(--primary-main);
  background-color: transparent;
  margin-top: 1rem;
  margin-left: 85%;
  cursor: pointer;
}

.btn_override {
  margin-left: 95%;
}

.reset_btn h4 {
  font-weight: 400;
  font-size: 14px;
}

/* OK */
.grid-files-details {
  margin-top: 2rem;
  height: calc(100% - 2rem);
  overflow-y: hidden;

  display: grid;
  grid-template-areas: "selected-files separator form-details";
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
}

.selected-files,
.form-details {
  min-width: 0;
}

.selected-files {
  grid-area: selected-files;
  padding-top: 1rem;
  padding-right: 1rem;
}

.separator {
  grid-area: separator;
  border: 1px solid #e8e8e8;
  height: 100%;
  width: 0px;
}

.form-details {
  grid-area: form-details;
  padding-top: 1rem;
  padding-left: 1rem;
}

.display-files-uploaded {
  border: 2px solid #e8e8e8;
  overflow-y: scroll;
  padding: 2rem;
  height: auto;
  margin-top: 2%;
  border-radius: 4px;
}

.fileList_headers {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
  height: 2rem;
  align-items: center;
  margin-bottom: 6px;
}

.fileList_headers span {
  font-size: 13px !important;
  font-weight: 700;
}

.file_table_row p {
  margin: 0.5rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  white-space: nowrap;
}

.step_three_title {
  font-weight: 600;
  font-size: 16px;
}

.step-three-details {
  max-height: 200px;
  overflow-y: auto;
  /* Añade scroll si el contenido excede la altura máxima */
}

.file_table_row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.file_table_cell.selected-files {
  flex: 9;
}

.file_table_cell.category {
  flex: 1;
  text-align: left;
}

.table-header {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  padding: 8px 0;
}

.selected_files_header {
  width: 80%;
}

.category_header {
  width: 20%;
}
`, "",{"version":3,"sources":["webpack://./src/components/shared/Modal/UploadFile/uploadModal.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,+BAA+B;EAC/B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,OAAO;AACP;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;;EAElB,aAAa;EACb,4DAA4D;EAC5D,yDAAyD;AAC3D;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".modal_upload {\n  height: 75vh;\n  width: 60vw;\n  background-color: white;\n  position: relative;\n  margin: 5% auto;\n  border-radius: 10px;\n  padding: 0.5rem 2rem;\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.stepOne-container {\n  justify-content: space-around;\n}\n\n.step_first {\n  display: flex;\n  flex-flow: column;\n}\n\n.upload_slide1 {\n  height: auto;\n}\n\n.file_list_slide1 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 3rem;\n  padding: 0 1.5rem;\n  font-weight: 700;\n  max-width: 90%;\n}\n\n.file_list_slide1 img {\n  cursor: pointer;\n}\n\n.file_list_slide_override {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 3rem;\n  font-weight: 700;\n}\n\n.file_title_list {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 90%;\n}\n\n.text_counter_container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-size: 11px;\n  color: #53565a;\n}\n\n.file_title_list p {\n  font-size: 14px;\n  font-weight: 400;\n  width: auto;\n  max-width: 90%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.override_list {\n  display: flex;\n  flex-direction: row;\n  width: 80%;\n  align-items: center;\n}\n\n.override_list p {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.upload_dropzone {\n  height: 20vh;\n  background-color: #e4e4e49d;\n  border-radius: 4px;\n  border: 2px dashed rgb(117, 117, 117);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.dropzone_info {\n  height: 20%;\n  width: 80%;\n  display: flex;\n  align-items: center;\n}\n\n.iconText_container {\n  display: flex;\n  align-items: center;\n}\n\n.dropzone_info hr {\n  height: 5vh;\n  width: 0.1vw;\n  border-width: 0;\n  color: #a7a8aa;\n  background-color: #a7a8aa;\n}\n\n.dropzone_info h2 {\n  margin: 0 0.5rem;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.remove_file_btn {\n  width: auto;\n  height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 3px;\n  background-color: transparent;\n  border: none;\n}\n\n.grid-files {\n  display: grid;\n  grid-template-areas: \"drop-input files_container\";\n  grid-template-columns: 1fr 1.5fr;\n  column-gap: 25px;\n}\n\n.files_container {\n  grid-area: files_container;\n  background-color: #f5f5f5;\n  border: 1px solid #d0d0ce;\n  display: flex;\n  flex-direction: column;\n  border-radius: 4px;\n}\n\n.files_container_header {\n  display: flex;\n  height: 15%;\n  background-color: white;\n  border-bottom: 1px solid #d0d0ce;\n  padding: 0 2rem;\n  align-items: center;\n  font-size: 12px;\n  border-radius: 8px;\n}\n\n.files_container_header h1 {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.files_container_content {\n  overflow-y: scroll;\n  padding: 2rem 1rem;\n  max-height: 30vh;\n}\n\n.upload_icon {\n  height: 24px;\n  width: 24px;\n  background-color: var(--primary-main);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.drop_text_container {\n  display: flex;\n  justify-content: center;\n  width: 70%;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n.upload_btn_modal {\n  height: 50%;\n  width: auto;\n  padding: 0 10px;\n  border-radius: 4px;\n  border: none;\n  background-color: var(--primary-main);\n  color: white;\n  font-weight: 700;\n  cursor: grab;\n}\n\n.upload_modal_btn_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n.error_message {\n  color: red;\n}\n\n.upload_slide2_content {\n  height: auto;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n}\n\n.filesDiv {\n  display: flex;\n  flex-flow: column;\n  overflow-y: scroll;\n  height: 20vh;\n  width: 100%;\n}\n\n.filesDetailList {\n  display: flex;\n  flex-flow: column;\n  overflow-y: auto;\n  max-height: 50vh;\n  margin-top: 20px;\n}\n\n.slide2_files {\n  height: 80%;\n  width: 40%;\n  display: flex;\n  overflow: scroll;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 1rem 1rem;\n}\n\n.slide2_files h2 {\n  margin: 0;\n}\n\n.slide2_details h2 {\n  margin: 0;\n}\n\n.slide2_details {\n  height: 80%;\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  padding: 1rem 3rem;\n  border-left: 1px solid #a7a8aa;\n  text-align: start;\n}\n\n.slide2_detaile_title {\n  align-items: center;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.slide2_detaile_title p {\n  font-size: 10px;\n}\n\n.slide2_details form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.fileName_listed {\n  display: flex;\n  flex-direction: row;\n}\n\n.fileName_container {\n  height: auto;\n  background-color: transparent;\n  display: flex;\n  width: 25vw;\n  align-items: center;\n  padding: 1rem;\n  border: none;\n  color: black;\n  margin-top: 1.5rem;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  padding-left: 20px;\n  padding-right: 2rem;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.fileName_container p {\n  margin: 0;\n  width: calc(90% - 15px);\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: justify;\n  white-space: nowrap;\n}\n\n.slide2_footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.fileName {\n  background-color: #f5f5f5;\n  padding: 8px 0px;\n  padding-left: 8px;\n  column-gap: 10px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  font-weight: 700;\n}\n\n.fileName-selected {\n  background-color: var(--primary-main);\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  width: 4px;\n  height: 40px;\n}\n\n.fileName_container.selected {\n  background-color: #f5f5f5;\n  transform: translate(50);\n  transform: translateX(10px);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.grid-override {\n  display: grid;\n  grid-template-areas: \"drop-input\" \"selectedFiles\";\n  grid-template-rows: 4fr 0.5fr;\n}\n\n.fileName_container.selected::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  background-color: var(--primary-main);\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.upload_slide3 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.upload_slide3 h1 {\n  margin: 0;\n}\n\n.loader {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 5;\n  background-color: rgba(66, 66, 66, 0.301);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.files_container_content h6 {\n  margin: 2rem 2rem;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.upload_title {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 28px;\n  margin-bottom: 1rem;\n}\n\n.reset_btn {\n  border: none;\n  color: var(--primary-main);\n  background-color: transparent;\n  margin-top: 1rem;\n  margin-left: 85%;\n  cursor: pointer;\n}\n\n.btn_override {\n  margin-left: 95%;\n}\n\n.reset_btn h4 {\n  font-weight: 400;\n  font-size: 14px;\n}\n\n/* OK */\n.grid-files-details {\n  margin-top: 2rem;\n  height: calc(100% - 2rem);\n  overflow-y: hidden;\n\n  display: grid;\n  grid-template-areas: \"selected-files separator form-details\";\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n}\n\n.selected-files,\n.form-details {\n  min-width: 0;\n}\n\n.selected-files {\n  grid-area: selected-files;\n  padding-top: 1rem;\n  padding-right: 1rem;\n}\n\n.separator {\n  grid-area: separator;\n  border: 1px solid #e8e8e8;\n  height: 100%;\n  width: 0px;\n}\n\n.form-details {\n  grid-area: form-details;\n  padding-top: 1rem;\n  padding-left: 1rem;\n}\n\n.display-files-uploaded {\n  border: 2px solid #e8e8e8;\n  overflow-y: scroll;\n  padding: 2rem;\n  height: auto;\n  margin-top: 2%;\n  border-radius: 4px;\n}\n\n.fileList_headers {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 1;\n  height: 2rem;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.fileList_headers span {\n  font-size: 13px !important;\n  font-weight: 700;\n}\n\n.file_table_row p {\n  margin: 0.5rem 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: justify;\n  white-space: nowrap;\n}\n\n.step_three_title {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.step-three-details {\n  max-height: 200px;\n  overflow-y: auto;\n  /* Añade scroll si el contenido excede la altura máxima */\n}\n\n.file_table_row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n}\n\n.file_table_cell.selected-files {\n  flex: 9;\n}\n\n.file_table_cell.category {\n  flex: 1;\n  text-align: left;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n  padding: 8px 0;\n}\n\n.selected_files_header {\n  width: 80%;\n}\n\n.category_header {\n  width: 20%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
